<template>
tygjhgjgh

</template>


<script setup>
/* eslint-disable */
import { ref } from "vue";
import api from "@/plugins/axios";

  try {
    const response = await api.get("/admin/dashboard/orders-last-10-days", {

    });
    console.log(response.data);


   
  } catch (error) {

    console.log("error");
    // serverError.value = true;
    // serverError.value = error.response?.data?.message || "networkError";
    // console.log(serverError);

  } finally {
       console.log("finally");

  }
</script>

